import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import { connect } from "react-redux";
import { DollarSign } from "react-feather";
import {
  getAllBannersRedux,
  uploadBannerRedux,
  updateBannerRedux,
  deleteBannerRedux,
} from "../../../actions";
import {
  uploadImage,
  updateImage,
  deleteImage,
} from "../../../firebase/firebase.utils";
import man from "./plus image.jpeg";
import { Search } from "react-feather";
import { CircleLoader } from "react-spinners";
export class Banners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      name: "",
      slug: "",
      parentCategory: "",
      productObj: null,
      loading: false,
      loading2: false,
      imageUrl: man,
      imageUrl2: man,
      file: "",
      checkedValues: [],
      selectAll: false,
      searchFor: "",
      visible: false,
      secondBanner: false,
      link: "",
    };
  }

  componentDidMount = async () => {
    this.props.getAllBannersRedux();
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  _handleImgChange = (e, i) => {
    e.preventDefault();

    const fileInput = e.target; // 🧠 store a reference before async code
    const file = fileInput.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        file: file,
        imageUrl: reader.result, // base64 preview
      });

      // 🛠️ Reset input safely
      if (fileInput) fileInput.value = "";
    };

    reader.onerror = (err) => {
      console.error("File reading error:", err);
    };

    reader.readAsDataURL(file);
  };

  // _handleImgChange = async (e, i) => {
  //   e.preventDefault();
  //   const { currentAdmin } = this.props;

  //   let reader = new FileReader();
  //   let file = e.target.files[0];
  //   const { imageUrl } = this.state;

  //   reader.onloadend = () => {
  //     imageUrl = reader.result;
  //     this.setState({
  //       file: file,
  //       imageUrl,
  //     });
  //   };
  //   if (file) {
  //     this.setState({ loading: true });
  //     reader.readAsDataURL(file);
  //     const imgUrl = await uploadImage(file, 'banners');
  //     console.log(imgUrl);

  //     this.setState({
  //       imageUrl: imgUrl,
  //     });
  //     console.log(imageUrl);
  //     this.setState({ loading: false });
  //   }
  // };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    let date = new Date();

    if (this.state.type === "upload") {
      // first upload the image in cpanel and then upload it to firestore database
      if (this.state.file) {
        this.setState({ loading: true });
        const reader = new FileReader();
        reader.readAsDataURL(this.state.file);
        const imgUrl = await uploadImage(this.state.file, "banners");
        console.log(imgUrl);

        this.setState({
          imageUrl: imgUrl,
        });
        console.log(imgUrl);
        this.setState({ loading: false });
        if (imgUrl) {
          let bannerObj = {
            id: date.getTime().toString(),
            name: this.state.name,
            banner: imgUrl,
            visible: this.state.visible,
            secondBanner: this.state.secondBanner,
            link: this.state.link,
          };
          await this.props.uploadBannerRedux(bannerObj);
        } else {
          toast.error("No image is given");
        }
      }
    } else if (this.state.type === "update") {
      this.setState({ loading: true });
      const reader = new FileReader();
      if (this.state.file) {
        reader.readAsDataURL(this.state.file);
      }

      const imgUrl = await updateImage(
        this.state.file,
        this.state.productObj.banner,
        "banners"
      );
      console.log(imgUrl);

      this.setState({
        imageUrl: imgUrl,
      });
      console.log(imgUrl);
      this.setState({ loading: false });
      if (imgUrl) {
        let bannerObj = {
          id: this.state.id,
          name: this.state.name,
          banner: imgUrl,
          visible: this.state.visible,
          secondBanner: this.state.secondBanner,
          link: this.state.link,
        };
        await this.props.updateBannerRedux(bannerObj);
      }
    }

    this.setState({
      id: "",
      name: "",
      slug: "",

      productObj: null,
      loading: false,
      loading2: false,
      imageUrl: man,
      imageUrl2: man,
      file: "",
      checkedValues: [],
      selectAll: false,
      visible: false,
      secondBanner: false,
      link: "",
    });
  };

  selectRow = (e, banner) => {
    if (!e.target.checked) {
      this.props.updateBannerRedux({ ...banner, visible: false });
    } else {
      this.props.updateBannerRedux({ ...banner, visible: true });
    }
  };

  render() {
    const { open, productObj } = this.state;
    const { banners, currentAdmin } = this.props;
    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title={"Banners"} parent="Products" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid kd-cash kd-prod kd-st--mint">
          <div className="row" style={{ justifyContent: "center" }}>
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderBottom: "1px solid gainsboro",
                  }}
                >
                  <h5>
                    <i
                      className="icofont-layout"
                      style={{
                        fontSize: "130%",
                        marginRight: "5px",
                        color: "var(--kd-sky-deep)",
                      }}
                    ></i>
                    Banners
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-around",
                    }}
                  >
                    {" "}
                    <li
                      style={{
                        border: "1px solid gainsboro",
                        borderRadius: "5rem",
                        padding: "0px 20px",
                        background: "whitesmoke",
                        marginRight: "20px",
                      }}
                    >
                      <form
                        className="form-inline search-form"
                        onSubmit={this.handleSubmit}
                      >
                        <div
                          // className="form-group"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <input
                            className={
                              "form-control-plaintext " +
                              (this.state.searchbar ? "open" : "")
                            }
                            name="searchFor"
                            value={this.state.searchFor}
                            type="search"
                            placeholder="Search Banner"
                            style={{ paddingLeft: 10 }}
                            onChange={this.handleSearchBarChange}
                          />
                          <span>
                            <Search
                              style={{
                                marginTop: "5px",
                                borderLeft: "1px solid gainsboro",
                                paddingLeft: "7px",
                                color: "gray",
                              }}
                            />
                          </span>
                        </div>
                      </form>
                    </li>
                    <li>
                      {" "}
                      <button
                        className="btn"
                        data-toggle="modal"
                        data-target="#personalInfoModal"
                        style={{
                          backgroundColor: "var(--kd-sky-deep)",
                          border: "none",
                          color: "white",
                          fontSize: 11,
                        }}
                        onClick={() => {
                          this.setState({
                            id: "",
                            name: "",
                            slug: "",
                            parentCategory: "",
                            productObj: null,
                            loading: false,
                            loading2: false,
                            imageUrl: man,
                            imageUrl2: man,
                            file: "",
                            checkedValues: [],
                            selectAll: false,
                            topCategory: false,
                            type: "upload",
                            visible: false,
                            secondBanner: false,
                            link: "",
                          });
                        }}
                      >
                        Add New Banner
                      </button>
                    </li>
                  </div>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <table className="table table-bordered table-striped table-hover">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "var(--kd-sky-deep)",
                              minWidth: "150px",
                              maxWidth: "150px",
                            }}
                          >
                            Active
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "var(--kd-sky-deep)",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Banner
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "var(--kd-sky-deep)",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "var(--kd-sky-deep)",
                              maxWidth: "150px",
                              minWidth: "150px",
                            }}
                          >
                            Link
                          </th>

                          <th
                            scope="col"
                            style={{
                              padding: "30px 15px",
                              color: "white",
                              backgroundColor: "var(--kd-sky-deep)",
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {banners.map((banner, index) => (
                          <tr key={index}>
                            <th scope="row">
                              {" "}
                              <div>
                                <span
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    name={banner.id}
                                    checked={banner.visible}
                                    style={{
                                      height: 20,
                                      width: 20,
                                    }}
                                    onChange={(e) => this.selectRow(e, banner)}
                                  />
                                </span>
                              </div>
                            </th>
                            <td>
                              <a href={banner.logo} target="_blank">
                                <img
                                  style={{ height: 100, width: 200 }}
                                  src={banner.banner || this.state.imageUrl}
                                />
                              </a>
                            </td>
                            <td>{banner.name}</td>
                            <td>{banner.link || "—"}</td>
                            <td>
                              <div
                                className="row"
                                style={{ justifyContent: "center" }}
                              >
                                <i
                                  className="icofont-edit"
                                  data-toggle="modal"
                                  data-target="#personalInfoModal"
                                  onClick={() => {
                                    this.setState({
                                      id: banner.id,
                                      name: banner.name,
                                      visible: banner.visible,
                                      secondBanner: banner.secondBanner,
                                      link: banner.link || "",
                                      imageUrl: banner.banner,
                                      type: "update",
                                      productObj: banner,
                                    });
                                  }}
                                  style={{
                                    color: "green",
                                    marginRight: 8,
                                    cursor: "pointer",
                                  }}
                                />{" "}
                                <i
                                  className="icofont-trash"
                                  data-toggle="modal"
                                  data-target="#deleteExpenseModal"
                                  onClick={() => {
                                    this.setState({
                                      productObj: banner,
                                    });
                                  }}
                                  style={{
                                    color: "red",
                                    marginLeft: 8,
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {banners.length === 0 && (
                      <EmptyState>No banners yet.</EmptyState>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div
          className="modal fade tb-modal"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "95%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "var(--kd-sky-deep)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  {productObj ? "Update" : "Add New"} Banner
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter banner name"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Link (optional)
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="link"
                      value={this.state.link}
                      onChange={this.handleChange}
                      placeholder="/shop-default"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                    <div style={{ marginTop: 3, color: "gray" }}>
                      A relative path on the website. If set, a "Shop now"
                      button will show on this banner and clicking it will
                      navigate here.
                    </div>
                  </div>

                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Banner Image
                    </label>
                    <div
                      className="box-input-file"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <img
                        className="img-50 lazyloaded blur-up"
                        src={this.state.imageUrl}
                        alt="#"
                        style={{
                          zIndex: 10,
                          cursor: "pointer",
                          border: "1px solid gainsboro",
                          borderRadius: 5,
                          minHeight: 100,
                          maxHeight: 100,
                          minWidth: 200,
                          maxWidth: 200,
                        }}
                        onClick={() => {
                          document.getElementById("upload-image-input").click();
                        }}
                      />

                      <input
                        id="upload-image-input"
                        className="upload"
                        type="file"
                        style={{
                          position: "absolute",
                          zIndex: 5,
                          maxWidth: "50px",
                          marginTop: "10px",
                        }}
                        onChange={(e) => this._handleImgChange(e, 0)}
                      />
                    </div>
                    <div style={{ marginTop: 3, color: "gray" }}>
                      Dimensions (7000 * 3500),
                      <br /> Dimensions (7000 * 2100)
                    </div>
                  </div>
                  <div className="form-group">
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <input
                        type="checkbox"
                        name={this.state.secondBanner}
                        checked={this.state.secondBanner}
                        onChange={(e) =>
                          this.setState({
                            secondBanner: !this.state.secondBanner,
                          })
                        }
                        style={{
                          height: 20,
                          width: 20,
                        }}
                      />

                      <div
                        style={{
                          marginLeft: 5,
                          fontWeight: "bold",
                          color: "#505050",
                          marginBottom: 5,
                        }}
                      >
                        2nd banner
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {/* <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "var(--kd-ink)",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  {productObj ? "Update" : "Add"} banner
                </button> */}
                <button
                  onClick={() => {
                    this.handleSubmit();
                  }}
                  className="btn"
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "var(--kd-ink)",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                    minWidth: 120,
                    minHeight: 40,
                  }}
                >
                  {!this.state.loading &&
                    (productObj ? "Update Banner" : "Add Banner")}
                  <CircleLoader
                    loading={this.state.loading}
                    style={{ marginTop: -8 }}
                    color="white"
                    size={15}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade tb-modal"
          id="deleteExpenseModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, margin: "auto", minWidth: "140%" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "var(--kd-sky-deep)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Delete Banner
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}>
                  <div>Are you sure you want to delete this Image?</div>
                </div>
                <table className="table table-bordered table-striped table-hover">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {productObj && (
                          <img
                            style={{ height: 70, width: 70 }}
                            src={productObj.banner}
                          />
                        )}
                      </td>
                      <td>{productObj && productObj.name}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "#B42318",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                  }}
                  onClick={() => {
                    // delete it from firestore
                    this.props.deleteBannerRedux(productObj.id);
                    // delte the image from cpanel
                    deleteImage(productObj.banner);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allUsers: state.users.users,
    currentAdmin: state.admins.currentAdmin,
    banners: state.categories.banners,
  };
};

export default connect(mapStateToProps, {
  getAllBannersRedux,
  uploadBannerRedux,
  updateBannerRedux,
  deleteBannerRedux,
})(Banners);
